import { useCallback, useContext, useEffect, useState } from "react";
import { autosaveInsert } from "../../util/helpers";
import AppContext from "../../context";
import tutorial from "../../assets/videos/tutorial.webm";

const DID = () => {
  const [mounted, setMounted] = useState(false);
  const [sessionSeconds, setSessionSeconds] = useState(0);
  const { isBrowser, triggerPriceUpdate, autoSave, handleSetGlobalModal } =
    useContext(AppContext);

  const increment = useCallback(() => {
    setSessionSeconds((sessionSeconds) => sessionSeconds + 1);
  });
  // autosave insert every minute.
  useEffect(() => {
    let timerTimeout = setTimeout(increment, 1000);

    if (sessionSeconds % 60 === 0 && sessionSeconds >= 60 && autoSave) {
      autosaveInsert();
    }
    return () => {
      clearTimeout(timerTimeout);
    };
  }, [increment, autoSave]);

  useEffect(() => {
    if (!mounted) setMounted(true);
    else {
      const alreadyLanded = window.localStorage.getItem("alreadyLanded");

      if (isBrowser && window.innerWidth < 800)
        alert("This site is configured to be used on a desktop device.");

      /* if (!alreadyLanded)
        handleSetGlobalModal(
          <div className="common-modal">
            <div className="common-modal__content content">
              <div className="landing-modal-content">
                <div>
                  <h2 className="landing-modal-content__header">
                    Welcome to the Drawer Insert Designer
                  </h2>
                  <p>The solution for custom made drawer inserts.</p>
                </div>
                <div>
                  <h3>What Is It?</h3>
                  <p>
                    It’s a 3D design tool that allows you to create and then
                    have manufactured a drawer insert to your specifications.
                  </p>
                  <p>You can order the insert 4 different ways.</p>
                  <p>
                    <b>Assembled</b> - Unfinished, and ready to install
                  </p>
                  <p>
                    <b>Ready to Assemble</b> - All the parts, sanded and ready
                    to be put together
                  </p>
                  <p>
                    <b>Finished</b> - Assembled with clear coat applied for
                    extra durability - ready to install
                  </p>
                  <p>
                    <b>Download the SVG file</b> - ready to be cut by you with a
                    laser and CNC.
                  </p>
                </div>
                <div>
                  <h3>How to Use It</h3>
                  <p>
                    <b>Step 1</b> - Start with an empty box to set up your own
                    dividers or begin with a template
                  </p>
                  <p>
                    <b>Step 2</b> - Set the outside dimensions for your insert
                  </p>
                  <p>
                    <b>Step 3</b> - Choose the material you would like to use
                  </p>
                  <p>
                    <b>Step 4</b> - Use the tools on the left to add or edit
                    dividers
                  </p>
                  <p>
                    <b>Step 5</b> - Save the file to your desktop at anytime if
                    you want to work on it later
                  </p>
                  <div className="is-flex is-justify-content-center padding-unset">
                    <button
                      className="button is-dark is-outlined has-text-weight-bold"
                      onClick={() => {
                        handleSetGlobalModal(
                          <div style={{ minWidth: "100%" }}>
                            <video controls autoPlay>
                              <source src={tutorial} />
                            </video>
                          </div>,
                          {
                            wide: true,
                            pronouncedCloseButton: true,
                          }
                        );
                      }}
                    >
                      Video Tutorial
                    </button>
                  </div>
                </div>
                <div>
                  <h3>How to Order</h3>
                  <p>
                    When you are happy with the design you have created and have
                    double checked your measurements, click Add to Cart or Order
                    Now in the bottom right corner and follow the payment steps
                    in Shopify.
                  </p>
                  <p>No need to make an account.</p>
                  <p>Ready to ship within 2 weeks of ordering.</p>
                </div>
                <div>
                  <h3>This Is a Beta Version</h3>
                  <p>
                    We have just launched this site and are constantly improving
                    it. If you have any comments, notice any bugs or are having
                    any issues using it you can contact us here.
                  </p>
                  <p>
                    If the 3D model does not load, try hitting the refresh
                    button in your browser.
                  </p>
                  <p>
                    It’s always a good idea to save your file to your desktop as
                    you work on it as you can reload it at any time.
                  </p>
                  <div className="is-flex is-justify-content-space-evenly padding-unset">
                    <a
                      href="mailto:admin@drawerinsertdesigner.com"
                      className="button is-dark is-outlined has-text-weight-bold"
                    >
                      Report an Issue
                    </a>
                  </div>
                </div>
                <div>
                  <h3>Contact Us</h3>
                  <div className="landing-modal-content__footer">
                    <div>
                      <ul>
                        <li>Drawer Insert Designer ℅ Varcroft &#38; Bianco</li>
                        <li>
                          {" "}
                          733 County Road 8 Douro Dummer, Ontario K0A 3L0
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ul>
                        <li>(705)652-3520</li>
                        <li> admin@drawerinsertdesigner.com</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>,
          { noOutsideClickClose: true, semiwide: true }
        ); */
    }
  }, [mounted]);
  return <canvas id="myCanvas" onClick={triggerPriceUpdate}></canvas>;
};

export default DID;
